import { PublicLayout } from '../../components/marketing/PublicLayout'
import { Hero } from '../../components/marketing/Hero'
import { ValueProps } from '../../components/marketing/ValueProps'
import { HowItWorks } from '../../components/marketing/HowItWorks'
import { FeatureShowcase } from '../../components/marketing/FeatureShowcase'

export default function LandingPage() {
  return (
    <PublicLayout>
      <Hero />
      <ValueProps />
      <HowItWorks />
      <FeatureShowcase />
    </PublicLayout>
  )
}
